import { HttpClient, provideHttpClient, withInterceptors } from "@angular/common/http";
import { inject, provideAppInitializer, provideZonelessChangeDetection } from "@angular/core";
import { bootstrapApplication } from "@angular/platform-browser";

import { environment } from "@environment";
import { authInterceptorFn, errorInterceptorFn } from "@interceptors";
import { APP_CONFIG, AbstractTranslateService, TranslateService } from "@services";

import { AppComponent } from "./app/app.component";

fetch(environment.configUrl)
  .then(resp => resp.json())
  .then(config => {
    bootstrapApplication(AppComponent, {
      providers: [
        provideZonelessChangeDetection(),
        {
          provide: AbstractTranslateService,
          useFactory: (http: HttpClient) => new TranslateService(http, "/assets/i18n/"),
          deps: [HttpClient],
        },
        provideAppInitializer(() => inject(AbstractTranslateService).init()),
        provideHttpClient(withInterceptors([authInterceptorFn, errorInterceptorFn])),
        { provide: APP_CONFIG, useValue: replaceConfig(config) },
      ],
    }).catch(err => console.error(err));
  });

function replaceConfig(config: Record<string, string>): Record<string, string> {
  if (environment.replace) {
    const domain = environment.production
      ? window.location.origin.split(".").slice(-2).join(".")
      : new URLSearchParams(window.location.search).get("domain") || "gmmm.tech";
    return Object.keys(config).reduce((res, key) => {
      return { ...res, [key]: config[key].replace("<domain>", domain) };
    }, {});
  }

  return config;
}
